import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';
import { typo } from '../../gatsby-theme-material-ui-top-layout/theme';

const fontOffset = '5px';
const negativeFontOffset = '-5px';

function BlockHeadline({ overline, content, variant, sizeRestriction, align, isMagenta }) {
  return (
    <Typography
      sx={[
        (theme) => ({
          textAlign: align,
          marginBottom: '32px',
          left: negativeFontOffset,
          position: 'relative',
          // Roboto-BlackItalic
          fontSize: theme.typography.pxToRem(36),
          [theme.breakpoints.up('lg')]: {
            fontSize: theme.typography.pxToRem(44),
          },
          fontWeight: theme.typography.fontWeightBolder,
          lineHeight: 1.09,
          textTransform: 'uppercase',
          fontStyle: 'italic',
          letterSpacing: 'normal',
        }),
        sizeRestriction === 'small' && { width: '70%' },
        sizeRestriction === 'normal' && { width: '90%' },
      ]}
      color="inherit"
      variant={variant}
    >
      <Typography
        variant="caption"
        sx={(theme) => ({
          display: 'block',
          paddingLeft: fontOffset,
          // Roboto-Blackitalic
          fontSize: theme.typography.pxToRem(16),
          fontWeight: typo.weights.bolder,
          color: isMagenta ? theme.palette.secondary.main : theme.palette.green.main,
          textTransform: 'uppercase',
          fontStyle: 'italic',
          letterSpacing: -0.09,
          [theme.breakpoints.up('lg')]: {
            fontSize: theme.typography.pxToRem(20),
          },
        })}
      >
        {overline}
      </Typography>
      <span>{content}</span>
      <Box
        component="span"
        sx={(theme) => ({
          fontFamily: 'Times New Roman',
          color: isMagenta ? theme.palette.secondary.main : theme.palette.green.main,
          fontSize: '1.6em',
          position: 'relative',
          left: '0.1em',
          top: '-1px',
          lineHeight: '0',
        })}
      >
        .
      </Box>
    </Typography>
  );
}

BlockHeadline.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  content: PropTypes.string.isRequired,
  overline: PropTypes.string,
  isMagenta: PropTypes.bool,
  sizeRestriction: PropTypes.oneOf(['small', 'normal', 'none']),
  variant: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'caption',
    'button',
    'overline',
  ]),
};

BlockHeadline.defaultProps = {
  variant: 'h2',
  sizeRestriction: 'small',
  overline: '',
  align: 'left',
  isMagenta: true,
};

export default BlockHeadline;
